import React from 'react'
import { Footer } from '@airbus/components-react/components'

const AppFooter = () => {
  return (
    <Footer primaryLinks={[]} theme='light'>
      <div>{eval('CONFIGAPP__APPVERSION') && 'Version ' + eval('CONFIGAPP__APPVERSION')}</div>
    </Footer>
  )
}

export default AppFooter
